import { UNIT_STRING } from "../../constants/StringConstant"
import { stringFormatting } from "./TextHelper"

export const FORM_NEED = {
  harusDiIsi: " Harus di isi",
  mustBeNumber: " Must be a number",
  moreThan: (value) => `more than ${value}`
}

export function getStringErrorMassage(dataShow, formNeed) {
  return dataShow + formNeed
}

export function getMaximumErrorString(maximumInput) {
  return "Maximum " + maximumInput + " character"
}

export function getMinimumErrorString(minimumInput) {
  return "Minimum " + minimumInput + " character"
}

export function getMaximumErrorNumber(maximumInput) {
  return `Value must be less than ${maximumInput}`
}

export function getMinimumErrorNumber(minimumInput) {
  return `Value must be greater than ${minimumInput}`
}

export function getHSTUnit(value) {
  return stringFormatting(value, UNIT_STRING.HST)
}

export const getCountDownToday = (value, todayText) => {
  if (value > 0) {
    return `${value} hari lagi`
  } else if (value < 0) {
    return `Terlewat ${Math.abs(value)} hari`
  } else if (value === 0 && todayText) {
    return todayText
  } else {
    return "-"
  }
}

export const getTonnageUnit = (value) => {
  return stringFormatting(value, "ton")
}